import { combineReducers } from 'redux';
import concepts from './concepts.ts';
import playDiagnostic from './diagnostics';
import display from './display';
import fillInBlank from './fillInBlank.ts';
import filters from './filtersReducer';
import generatedIncorrectSequences from './generatedIncorrectSequences';
import lessons from './lessons.ts';
import massEdit from './massEdit';
import playLesson from './questionReducer';
import questions from './questions.ts';
import responses from './responsesReducer';
import sessions from './sessions';
import titleCards from './titleCards.ts';

const combinedReducers = combineReducers({
  concepts,
  display,
  fillInBlank,
  filters,
  generatedIncorrectSequences,
  lessons,
  massEdit,
  playDiagnostic,
  playLesson,
  questions,
  responses,
  sessions,
  titleCards,
});

export default combinedReducers;
